import React from 'react';
import {
  DialogActions,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  IconButton,
  Divider,
} from '@material-ui/core';

export function EeDialog(props: any) {
  const {
    open,
    title,
    header,
    onCancel,
    onConfirm,
    children,
    cancelButtonLabel,
    confirmButtonLabel,
    width = 700,
  } = props;
  return (
    <Dialog
      className={props.className}
      maxWidth={false}
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div style={{ width: width }}>
        <DialogTitle>
          <div className="d-flex">
            <div className="flex-grow-1">{title}</div>
            <IconButton
              onClick={onCancel}
              style={{ position: 'absolute', top: 8, right: 8 }}
            >
              <i className="material-icons" style={{ color: '#1e1e1e' }}>
                highlight_off
              </i>
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {header}
          </DialogContentText>
          {children}
        </DialogContent>
        <DialogActions className="d-flex align-items-center">
          <Button
            onClick={onCancel}
            color="primary"
            variant="outlined"
            className="mr-auto"
          >
            {cancelButtonLabel || 'Cancel'}
          </Button>
          <Button
            onClick={onConfirm}
            color="primary"
            variant="contained"
            autoFocus
          >
            {confirmButtonLabel || 'Confirm'}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
}
